export const en = {
    "add": "Add",
    "button-delete": "Delete",
    "button-not-required": "Cancel",
    "copied": "Copied",
    "draft": "Draft",
    "no": "No",
    "published": "Published",
    "save": "Save",
    "saved": "Saved",
    "to-copy": "Copy",
    "yes": "Yes"
} as const;
export const ru = {
    "add": "Добавить",
    "button-delete": "Удалить",
    "button-not-required": "Не надо",
    "copied": "Скопировано",
    "draft": "Черновик",
    "no": "Нет",
    "published": "Опубликованная версия",
    "save": "Сохранить",
    "saved": "Сохранено",
    "to-copy": "Скопировать",
    "yes": "Да"
} as const;